/**
 * @generated SignedSource<<2ad633545f79188b3febbcb45df17f80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditVisibilitySelectorQuery$variables = {};
export type EditVisibilitySelectorQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToTemplates: boolean;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"BillingIdentityFeaturesPaywall_viewer">;
  };
};
export type EditVisibilitySelectorQuery = {
  response: EditVisibilitySelectorQuery$data;
  variables: EditVisibilitySelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "hasAccessToTemplates",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "templates"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"templates\")"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditVisibilitySelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BillingIdentityFeaturesPaywall_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EditVisibilitySelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "featureAccess",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bbfe56c4fd2fae4178f5499834da4651",
    "id": null,
    "metadata": {},
    "name": "EditVisibilitySelectorQuery",
    "operationKind": "query",
    "text": "query EditVisibilitySelectorQuery {\n  viewer {\n    account {\n      billingAccount {\n        hasAccessToTemplates: hasAccessToFeature(feature: templates)\n        id\n      }\n      id\n    }\n    ...BillingIdentityFeaturesPaywall_viewer\n    id\n  }\n}\n\nfragment BillingIdentityFeaturesPaywall_viewer on Viewer {\n  account {\n    billingAccount {\n      featureAccess\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9bdb044dccc073134d59b869493de320";

export default node;
